/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Start_ButtonInputs */

const en_welcome_start_button = /** @type {(inputs: Welcome_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View 3D demo`)
};

const fr_welcome_start_button = /** @type {(inputs: Welcome_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la démo 3D`)
};

const ms_sg2_welcome_start_button = /** @type {(inputs: Welcome_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat demo 3D`)
};

/**
* | output |
* | --- |
* | "View 3D demo" |
*
* @param {Welcome_Start_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_start_button = /** @type {((inputs?: Welcome_Start_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Start_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_start_button(inputs)
	if (locale === "fr") return fr_welcome_start_button(inputs)
	return ms_sg2_welcome_start_button(inputs)
});